import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const frontendUrl = window.location.href;

export const historiqueService = {
  async getList(ref) {
    try {
      const result = await axios.get(`${apiUrl}/history_demande`, {
        lien: frontendUrl,
        params: { ref: ref },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async downloadUploadedFiles(usr) {
    return await axios.get(`${apiUrl}/getCompressedFileById/`, {
      params: { user_id: usr.id_identite },
      responseType: "blob",
    });
  },
  async getOffreList() {
    try {
      const result = await axios.get(`${apiUrl}/offre_externe`);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async getListeCandidat(id_type, status = "complet") {
    try {
      const result = await axios.get(`${apiUrl}/liste_external_candidat`, {
        params: { id_type: id_type, status: status },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },

  async downloadAllDocByIdPosition(id_position, state = "complet") {
    try {
      return await axios.get(`${apiUrl}/dowloadExternalOffreDocs`, {
        params: { id_position: id_position, state: state },
        responseType: "blob",
      });
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        return error.response;
      }
    }
  },
  async downloadCV(ref) {
    try {
      const result = await axios.get(`${apiUrl}/identity_cv`, {
        params: { ref: ref },
        responseType: "blob",
      });
      return result;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
};
